<template>
  <tbody>
  <FinanceInvoiceShowTableItem
    v-for="(work, w) in works" :key="'work' + w"
    :work="work"
    :position="w + 1"
    :edit="edit"
    :on-percent-change="onPercentChange"
  />
  <template v-if="extras.length > 0">
    <tr class="grid_table fw500">
      <td>{{ works.length + 1 }}</td>
      <td>
        {{
          $formatTime(Object.values(extras).reduce((sum, current) => {
            return sum + current['approved_report']
          }, 0))
        }}
      </td>
      <td>{{ localStorage.translations.pages.finance['period-table']['total-extra'] }}</td>
      <td>{{ $formatCurrency(extras[0].price) }}</td>
      <td v-if="edit" class="pa-0 pointer">
        <v-select
          dense
          hide-details
          outlined
          class="f12 none_border"
          v-model="extra_vat_code.value"
          :items="listVatCode"
          item-value="code"
          item-text="percent"
          :placeholder="extra_tax_percent !== null ? String(extra_tax_percent) : '—'"
          :menu-props="{ bottom: true, offsetY: true }"
          @change="percentChange"
          :rules="[(v) => !!v || '']"
        >
          <template v-slot:append>
            <div class="f12 none_border fw500">%</div>
          </template>
          <template v-slot:item="scope">
            {{ scope.item.percent + '% ' + scope.item.description }}
          </template>
        </v-select>
      </td>
      <td v-else>{{ (finSystem === 'manual' ? extras[0].tax_percent || 0 : extra_tax_percent) + ' %' }}</td>
      <td>
        {{ $formatCurrency(extras.reduce((sum, current) => { return sum + current['total_price'] }, 0)) }}
      </td>
      <td>
        {{
          extra_tax_percent !== null || finSystem === 'manual'
            ? $formatCurrency(extras.reduce((sum, current) => { return sum + current['total_price_with_tax'] }, 0))
            : $formatCurrency(0)
        }}
      </td>
    </tr>
    <FinanceInvoiceShowTableItem
      v-for="(extra, e) in extras" :key="'extra' + e"
      :work="extra"
      :position="works.length + 1 + '.' + Number(e + 1)"
      is-extra
    />
  </template>
  </tbody>
</template>

<script>
import FinanceInvoiceShowTableItem from "components/finance/invoice/FinanceInvoiceShowTableItem";
import {mapGetters} from "vuex";

export default {
  name: "FinanceInvoiceShowTable",
  components: {FinanceInvoiceShowTableItem},
  props: {
    works: {
      type: Array,
      default: () => {
        return []
      }
    },
    extras: {
      type: Array,
      default: () => {
        return []
      }
    },
    edit: Boolean,
    onPercentChange: {},
    tax: {
      type: [Number, String],
      default: 0
    },
    extra_tax_percent: {
      type: [Number, String],
      default: 0
    },
    extra_vat_code: {
      type: Object,
      default: () => {
        return {value: null}
      }
    },
    finSystem: {
      type: String,
      default: 'manual'
    },
  },
  computed: {
    ...mapGetters('commonVatCode', {listVatCode: 'getCommonVatCodeGrid'}),
    showData() {
      return this.extras.every((current) => {
        return current['tax_percent'] === this.tax
      })
    }
  },
  methods: {
    percentChange() {
      if (this.onPercentChange)
        this.onPercentChange(this.listVatCode.filter(i => i.code == this.extra_vat_code.value)[0].id)
    }
  }
}
</script>
